export default "__VITE_ASSET__BGdKc1Vf__"